export const CurrencyCodes = [
  {
    "name": "US Dollar",
    "code": "USD"
  },
  {
    "name": "Canadian Dollar",
    "code": "CAD"
  }
]